import { Injectable } from '@angular/core';
import 'leaflet';
import 'leaflet-bing-layer';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import packageInfo from '../../../package.json';

const version: string = packageInfo.version;
const year: number = new Date().getFullYear();
const mapBoxToken = 'pk.eyJ1Ijoic3RlZWx5NjAwIiwiYSI6ImNqZTdjdzdsNzBhNHIzM21yNGx3azc4MG4ifQ.S4t-jWGE5Hy29cTKaC7-qg'
const openWeatherMapToken = '090f4cf6a9103c6871e56100fbd59b38';
const mapWorldportImageBounds = new L.latLngBounds(L.latLng(38.15256666, -85.75868611), L.latLng(38.19161111, -85.71448888)) // southwest, northeast
const mapWorldportImageDay = 'assets/images/map-worldport-day.svg';
const mapWorldportImageNight = 'assets/images/map-worldport-night.svg';
declare let L: any;
const env: string = environment.name;
@Injectable({
  providedIn: 'root',
})
export class MapLayerService {


  private activeLayer = new BehaviorSubject<string>('');
  _activeLayer = this.activeLayer.asObservable();


  constructor() {}

  public updateActiveLayer(data: string): void{
     this.activeLayer.next(data);
  }


  makeCitiesLayer(): L.LayerGroup {
    const littleton = L.marker([39.61, -105.02]).bindPopup('This is Littleton, CO.'),
      denver = L.marker([39.74, -104.99]).bindPopup('This is Denver, CO.'),
      aurora = L.marker([39.73, -104.8]).bindPopup('This is Aurora, CO.'),
      golden = L.marker([39.77, -105.23]).bindPopup('This is Golden, CO.');
    return L.layerGroup([littleton, denver, aurora, golden]);
  }

  makeCloudsOverlay(): L.TileLayer {
    return L.tileLayer('https://{s}.tile.openweathermap.org/map/clouds/{z}/{x}/{y}.png?appid={accessToken}', {
        maxZoom: 19,
        attribution: `&copy; UPS ${year} | CVV v${version} ${env}`,
        accessToken: openWeatherMapToken,
        opacity: 0.5,
      });
  }

  makeSatelliteBaseMap(): L.TileLayer {
    return L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
      attribution: `&copy; UPS ${year} | CVV v${version} ${env}`,
      });
  }

  makeDarkBaseMap(): L.TileLayer {
    return L.tileLayer('https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png', {
      attribution: `&copy; UPS ${year} | CVV v${version} ${env}`,
        subdomains: 'abcd',
        maxZoom: 19,
      });
  }

  makeWorldportBaseMap(): L.TileLayer {
    return L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 18,
      minZoom: 3,
      attribution: `&copy; UPS ${year} | CVV v${version} ${env}`,
    });
  }

  makeWorldportDayMap(): L.ImageOverlay{
    return L.imageOverlay(mapWorldportImageDay, mapWorldportImageBounds, {
      attribution: `&copy; UPS ${year} | CVV v${version} ${env}`
    });
  }

  makeWorldportNightMap(): L.ImageOverlay{
    return L.imageOverlay(mapWorldportImageNight, mapWorldportImageBounds, {
      attribution: `&copy; UPS ${year} | CVV v${version} ${env}`
    });
  }

  makeMapBoxBaseMap(): L.TileLayer{
    return L.tileLayer(
      `https://api.mapbox.com/styles/v1/mapbox/emerald-v8/tiles/{z}/{x}/{y}?access_token=${mapBoxToken}`, {
          tileSize: 512,
          zoomOffset: -1
      });
  }

  makeBingBaseMap(): L.TileLayer{
    return L.tileLayer.bing('AuCzEFrF_GFA_w97gu68Q6bPVkiLmDdN3iEBD-kM9gGn8e-3S2QHRcc7ZuPZXdt4');
  }

  initBaseMaps(): L.Control.LayersObject{
    return {
     "Satalite": this.makeSatelliteBaseMap(),
     "Dark": this.makeDarkBaseMap(),
     "Bing": this.makeBingBaseMap()
    };
  }

  initOverlayMaps(): L.Control.LayersObject{
    return {
      "Colorado Cities": new L.LayerGroup([this.makeCitiesLayer()]),
      "Clouds": this.makeCloudsOverlay()
      };
  }


}
